import { WorkoutType } from '../../config/workouttype';

export class HomeTimeSlot {
  public workoutType: WorkoutType;
  public startTime: number;
  public booked: boolean;
  public bookedInAnotherGym: boolean;
  public workoutId: string | null;
}
